module.exports = __webpack_public_path__ + "static/img/D’ici_2050.1f176a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/D’ici_2050.jpg
// module id = BapY
// module chunks = 0